import { GameTable } from '../game-table';
import { TableEvents } from '../table-events.enum';
import { TableEventInfo } from './table-event-info';

export class CardHidden extends TableEventInfo {
    public audio = new Audio('pictures/sounds/card_new.mp3');
    getEventType(): TableEvents {
        return TableEvents.CARD_HIDDEN;
    }

    next(gameTable: GameTable): void {
        const player = gameTable.getPlayer(this.seat);
        player.addHoleCard(this.card);
        if (gameTable.isSoundsOn) {
            this.audio.play();
        }
    }

    prev(gameTable: GameTable): void {
        const player = gameTable.getPlayer(this.seat);
        player.removeCard(this.card);
    }
}
